import { trackError } from '@billy/track-error'

import { getBrazeConfig, isBrazeInitialized, UserIdentity } from './brazeHelpers'

export const initializeBraze = (): boolean => {
  if (isBrazeInitialized()) {
    return true
  }

  const config = getBrazeConfig()
  if (!config) {
    return false
  }

  try {
    window?.braze?.initialize(config.apiKey, {
      baseUrl: config.sdkEndpoint,
      enableLogging: config.enableLogging,
      allowUserSuppliedJavascript: config.allowUserSuppliedJavascript,
    })

    window?.braze?.automaticallyShowInAppMessages?.()
    window?.braze?.openSession?.()

    return true
  } catch (error) {
    trackError(error)
    return false
  }
}

export const trackEvent = (eventName: string, properties?: Record<string, any>): void => {
  try {
    if (!isBrazeInitialized()) {
      return
    }
    window?.braze?.logCustomEvent(eventName, properties)
  } catch (error) {
    trackError(error)
  }
}

export const setUserIdentity = (user: UserIdentity): void => {
  try {
    if (!isBrazeInitialized()) {
      return
    }
    window?.braze?.changeUser(user.globalId)
    const brazeUser = window?.braze?.getUser()
    if (!brazeUser) {
      trackError('Unable to get Braze user instance')
      return
    }

    // Split name into first and last name
    const nameParts = user.name.trim().split(' ')
    const firstName = nameParts[0] || ''
    const lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : ''

    brazeUser.setEmail?.(user.email)
    brazeUser.setFirstName?.(firstName)
    brazeUser.setLastName?.(lastName)
    brazeUser.setLanguage?.(user.locale.split('_')[0])
  } catch (error) {
    trackError(error)
  }
}
